var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"OperateLhc-10"},[_c('group',{attrs:{"client":_vm.client,"list":_vm.Table[0],"length":5,"show-total":"end"}}),_c('BoardFast',{attrs:{"client":_vm.client,"group":[0],"step":true,"default-step":0.01}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }